export const IndicatorType = {
    Biological: 1,
    Protein: 2,
    ChemicalSterilizer: 3,
    ChemicalWasher: 4,
    Disinfection: 5
}